import React, { useEffect } from 'react';
import gsap from 'gsap';

export default function SectionOne() {
  useEffect(() => {
    gsap.from(".nrccs-home", { duration: 1, y: 100, opacity: 0 });
    gsap.to(".nrccs-home", { duration: 1, y: 0, opacity: 1 });
  }, []);

  const GoToAboutUs = () => {
    window.location.href = "/about_us";
  }
  
  // style={{ backgroundColor: "rgba(0, 0, 0, 0.4)" }} 
  // bg-[#1E2332]
  return (
    <section
      className="w-screen lg:h-[85vh] h-96 bg-center bg-cover lg:px-24 flex justify-center items-end font-malaya pb-6"
      style={{ backgroundImage: `url("/first.JPG")` }}
    >
      <div style={{ backgroundColor: "rgba(0, 0, 0, 0.4)" }} className="lg:w-[32rem] w-full lg:px-5 lg:pb-10 flex flex-col justify-center items-center">
        <p className="text-center text-slate-50 lg:text-4xl text-xl lg:pt-8 lg:px-0 p-4 nrccs-home uppercase font-semibold">
          New Rochelle <span className="text-yellow-400">Council</span> of community services
        </p>
        <p className="nrccs-home italic text-center text-xl text-gray-300 pb-6">Join our community today</p>
        <button onClick={GoToAboutUs} className="text-slate-50 uppercase nrccs-home border py-3.5 w-40 text-sm font-semibold relative group">
          <div class="absolute inset-0 w-0 bg-slate-50 transition-all duration-300 ease-out group-hover:w-full"></div>
          <span className="relative group-hover:text-[#1E2332]">
            Learn more
          </span>
        </button>
      </div>
    </section>
  );
}
